module.exports = __webpack_public_path__ + "static/media/as.aa720f0c.svg";